module.exports = __webpack_public_path__ + "img/button.34d58787.svg";